import { getCookieValue, setCookie } from './_cookies.js';
/**
 * Fetches & renders EMS banner if active
 */

// General AJAX call or render for related posts
export var renderEmsBanner = function() {
  let emergency = false;
  let banner = document.getElementById('emergency-banner');
  let body = document.getElementsByTagName('body')[0];

  if ( banner ) {
    if (!getCookieValue('ems') && !getCookieValue('emsColor')) {
      let axios = require('axios');
      const host = window.location.host ?? 'www.ochsner.org';

      axios
        .get(`https://${host}/emergency.json`)
        .then(response => {
          let data = response.data;
          let active = data.enableBanner;

          if( active ) {
            emergency = true;
            body.classList.add('emergency-banner-active');
            let color = "bg-" + kebabCase(data.brandColor.label);
            banner.classList.add( color );
            let template = require('./handlebars/emsBanner.handlebars');
            let html = template({ data: data });
            let cleanHtml = html
              .replace(/(\r\n|\n|\r)/gm, "")
              .replace(/  +/gm, " ")
              .replace(/\&nbsp\;/gm, " ");
            banner.innerHTML = html;
            setCookie("ems",btoa(cleanHtml), (1/96));
            setCookie("emsColor", color, (1/96));
          } else {
            setCookie('ems', 0, (1/96));
          }
        })
    }
  }
}

const kebabCase = str => str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .join('-')
    .toLowerCase();

// Execute when document is done loading
if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
	renderEmsBanner();
} else {
  document.addEventListener("DOMContentLoaded", renderEmsBanner);
}
